import React from 'react';
import { Row, Col, Button } from 'reactstrap';
import { T } from '../../../traks';
import OrderTotal from './OrderTotal';
import { default_currency } from '../../../Site';

const OrderFooter = ({
  total,
  totalNoVat,
  currency = default_currency,
  onBack,
  onNext,
  backLabel = <T>Back</T>,
  nextLabel = <T>Next</T>,
  showOrderTotal = true,
  disableNext = false,
  formId,
  hideNextButton = false,
}) => (
  <footer>
    {/* Desktop Layout */}
    <Row className="ml-0 px-2 py-3 w-100 order-details-footer d-none d-sm-flex">
      {showOrderTotal && (
        <OrderTotal
          total={total}
          totalNoVat={totalNoVat}
          currency={currency}
          colSize={6}
        />
      )}
      <Col sm={showOrderTotal ? 6 : 12} className="text-right">
        {onBack && (
          <Button className="ad_new_game_button px-5 py-0-75 mr-2" onClick={onBack}>
            {'<'} {backLabel}
          </Button>
        )}
        {!hideNextButton && (onNext || formId) && (
        <Button
          type={formId ? "submit" : "button"}
          form={formId}
          className="ad_new_game_button px-5 py-0-75"
          onClick={formId ? undefined : onNext}
          disabled={disableNext}
        >
          {nextLabel} {'>'}
        </Button>
      )}
      </Col>
    </Row>

    {/* Mobile Layout */}
    <Row className="ml-0 px-2 py-3 w-100 order-details-footer d-flex d-sm-none">
      {showOrderTotal && (
        <OrderTotal
          total={total}
          totalNoVat={totalNoVat}
          currency={currency}
          colSize={12}
        />
      )}
      <Col xs="12" className="text-right">
        {onBack && (
          <Button className="ad_new_game_button px-5 py-0-75 mr-2" onClick={onBack}>
            {'<'} {backLabel}
          </Button>
        )}
        {!hideNextButton && (onNext || formId) && (
        <Button
          type={formId ? "submit" : "button"}
          form={formId}
          className="ad_new_game_button px-5 py-0-75"
          onClick={formId ? undefined : onNext}
          disabled={disableNext}
        >
          {nextLabel} {'>'}
        </Button>
      )}
      </Col>
    </Row>
  </footer>
);

export default OrderFooter;



// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Globals/OrderFooter.js